<script lang="ts">
import type { CalendarGridHeadProps } from '..'
import { CalendarGridHead } from '..'

export interface DatePickerGridHeadProps extends CalendarGridHeadProps {}
</script>

<script setup lang="ts">
const props = defineProps<DatePickerGridHeadProps>()
</script>

<template>
  <CalendarGridHead v-bind="props">
    <slot />
  </CalendarGridHead>
</template>
